import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {ShopCreature} from "@/store/shop/types";
import TextUtils from "@/utils/text-utils";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import CU from "@/utils/c-u";
import {Tr} from "@/i18n/i18n";

export class PortalHeroPanel extends ShopCreaturePanel {

    constructor(scene: Phaser.Scene, x: number, y: number, sc: ShopCreature,
                statClickCallback: (creatureId:string) => void, callback: () => void,
                myNsCount: number, haveAlready: boolean) {
        super(scene, x, y, sc, statClickCallback, callback, {myNsCount: myNsCount, haveAlready: haveAlready, callback: callback});
    }

    protected getPriceText(sc: ShopCreature): string {
        return String(sc.price);
    }

    protected getBtnIcAtlas(): string | undefined {
        return Keys.ATLAS_PROFILE;
    }

    protected getBtnIcImg(): string {
        return Keys.UI_GOLDEN_CHECK;
    }

    protected getDescFontSize(): number {
        return 11;
    }

    protected setupExpansions(sc: ShopCreature, data: any) {
        let myNsCount = Math.min(data.myNsCount, sc.price);
        let haveAlready = data.haveAlready;
        let callback = data.callback;

        let have = TextUtils.addTextAdvanced(this.scene, Tr('hv'), 139, 152,
            '#adadad', 12, 'normal', 350, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        have.setStroke('#000000', 1);

        let reqCount = sc.price;

        let haveVal = TextUtils.addTextAdvanced(this.scene, String(myNsCount) + '/' + String(reqCount), have.getTopRight().x! / CU.S + 5, have.y / CU.S,
            '#9cdb57', 12, 'normal', 350, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        haveVal.setStroke('#000000', 1);

        this.add([have, haveVal]);

        let pos = have.getTopRight().x! / CU.S + 50;
        for (let i = 0; i < reqCount; i++) {
            let circle = SpriteUtils.addImage(this.scene!, pos, have.y / CU.S, Keys.FRM_RADIO_OUT, undefined, 0.35)
                .setOrigin(0.5, 0.5).setAlpha(0.9);
            this.add(circle);
            pos += 25;
        }

        pos = have.getTopRight().x! / CU.S + 50;
        for (let i = 0; i < myNsCount; i++) {
            let circle = SpriteUtils.addImage(this.scene!, pos, have.y / CU.S, Keys.FRM_RADIO_IN, undefined, 0.35)
                .setOrigin(0.5, 0.5).setAlpha(0.9);
            this.add(circle);
            pos += 25;
        }

        if (!haveAlready && myNsCount >= sc.price) {
            let buyButton = SpriteUtils.scale(new SquareButton(this.scene, 515, 85, 0, Keys.UI_ART_GREEN_BUTTON,
                this.getBtnIcAtlas(), this.getBtnIcImg(), this.getButtonText(), false), 0.8 / CU.S);

            buyButton.setCallback(() => {
                callback();
            });
            this.add(buyButton);
        } else if (haveAlready) {
            let check = SpriteUtils.addSprite(this.scene!, 515, 85, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK);
            this.add(check);
        }
    }

    protected createBuyButton(multiple: boolean) {
        return undefined;
    }

    protected showPricesPrices(): boolean {
        return false;
    }

    protected getTitleShift(): number {
        return -13;
    }

    protected getTypeShift(): number {
        return 35;
    }

    protected getDescriptionShift(): number {
        return 14;
    }

    protected getButtonText(): string {
        return Tr('get');
    }
}